<template>
  <div>
    <div v-if="showCalendar">
      <b-dropdown
        split
        :text="package_category.meta.options_label || trans('all_options')"
        :variant="tab == 0 ? 'branded' : 'link'"
        :class="tab == 0 ? '' : 'text-branded'"
        @click="tab = 0"
      >
        <b-dropdown-item
          :href="`${iframeUrlPrefix}/org/${organization.id}/packages/${package_category.id}${buildQuery('description')}`"
          link-class="ml-3 nav-package description"
          active
        >
          {{ package_category.name }}
          <small class="text-muted">({{ (package_category.meta.options_label || trans('all_options')).toLowerCase() }})</small>
        </b-dropdown-item>
        <b-dropdown-item
          v-for="p in packages" :key="p.id"
          :href="`${iframeUrlPrefix}/org/${organization.id}/package/${p.id}${buildQuery('description')}`"
          link-class="nested nav-package description"
        >
          <span :class="!p.visible ? 'text-danger' : ''">{{ p.name }}</span>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown
        split
        :text="trans('calendar')"
        :variant="tab == 1 ? 'branded' : 'link'"
        :class="tab == 1 ? '' : 'text-branded'"
        @click="tab = 1"
      >
        <b-dropdown-item
          :href="`${iframeUrlPrefix}/org/${organization.id}/packages/${package_category.id}${buildQuery('availability')}`"
          link-class="ml-3 nav-package availability"
          active
        >
          {{ package_category.name }}
          <small class="text-muted">({{ (package_category.meta.options_label || trans('all_options')).toLowerCase() }})</small>
        </b-dropdown-item>
        <b-dropdown-item
          v-for="p in packages" :key="p.id"
          :href="`${iframeUrlPrefix}/org/${organization.id}/package/${p.id}${buildQuery('availability')}`"
          link-class="nested nav-package availability"
        >
          <span :class="!p.visible ? 'text-danger' : ''">{{ p.name }}</span>
        </b-dropdown-item>
      </b-dropdown>
      <cart-link
        v-if="invoice"
        :invoice="invoice"
        :active="tab == 2"
        @click="tab = 2"
      ></cart-link>
    </div>
    <div v-if="showCalendar" v-show="tab == 0" class="mt-3">
      <slot></slot>
    </div>
    <div v-if="showCalendar" v-show="tab == 1" class="mt-3">
      <package-category-calendar
        v-if="invoice !== undefined"
        :organization="organizationWithConnectedClient"
        :package_category="package_category"
        :invoice="invoice"
        :page="showPage"
        @invoice="invoice = $event"
        @url-change="onUrlChange"
        @client-changed="onClientChanged"
        @last-invoice-recipient="onLastInvoiceRecipientChanged"
      ></package-category-calendar>
    </div>
    <div v-if="!!invoice && showCalendar" v-show="tab == 2" class="mt-3">
      <cart-content
        :organization="organizationWithConnectedClient"
        :invoice="invoice"
        show-close
        @invoice="invoice = $event"
        @invoiceempty="onEmptyCart"
        @close="tab = 1"
        @click="onCheckout"
      ></cart-content>
    </div>
    <div v-if="!showCalendar" class="mt-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import PackageCategoryCalendar from './PackageCategoryCalendar'
  import CartLink from './CartLink'
  import CartContent from './CartContent'
  import querystring from 'querystring'

  export default {
    props: {
      organization: Object,
      package_category: Object,
      packages: Array,
      page: Object,
    },
    components: {
      PackageCategoryCalendar,
      CartLink,
      CartContent,
    },
    data() {
      let query = querystring.parse(window.location.search.substring(1))
      let meta = this.package_category.meta
      let tab = 0
      if (meta &&
        meta.show_calendar &&
        (query.p == 'availability' || (!query.p && meta.default_tab == 'availability')))
        tab = 1
      return {
        trans: trans,
        moment: moment,
        iframeUrlPrefix: _.iframeUrlPrefix,
        busy: false,
        error: null,
        tab: tab,
        invoice: undefined,
        connected_client: undefined,
        last_invoice_recipient: undefined,
      }
    },
    computed: {
      showPage() {
        return this.tab == 0 ? 'description' : 'availability'
      },
      showCalendar() {
        return !!this.package_category.meta && this.package_category.meta.show_calendar
      },
      organizationWithConnectedClient() {
        let organization = _.cloneDeep(this.organization)
        if (this.connected_client !== undefined) organization.connected_client = this.connected_client
        if (this.last_invoice_recipient !== undefined) organization.last_invoice_recipient = this.last_invoice_recipient
        return organization
      },
    },
    methods: {
      onClientChanged() {
        // Reload client from back-end and inject it into the organization object
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/connected`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.connected_client = !_.isEmpty(response.data) ? response.data : null
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onLastInvoiceRecipientChanged(last_invoice_recipient) {
        this.last_invoice_recipient = last_invoice_recipient
      },
      buildQuery(p) {
        let query = window.location.href.split('?')[1]
        query = query ? ('?' + query) : null
        if (!p) return query
        let r = p == 'description' ? 'availability' : 'description'
        return query ? query.replace(r, p) : `?p=${p}`
      },
      onUrlChange() {
        // Update nav links to have the same query string
        /*let query = this.buildQuery()
        if (query) {
          document.querySelectorAll('a.nav-package').forEach(a => {
            let q = a.className.indexOf('availability') >= 0 ? this.buildQuery('availability') :
              (a.className.indexOf('description') >= 0 ? this.buildQuery('description') : query)
            a.href = a.href.split('?')[0] + q
          })
        }*/
      },
      onCheckout() {
        let session = ''
        if (window.session_id) {
          session = `?_session=${window.session_id}`;
        }
        window.location = `${_.iframeUrlPrefix}/org/${this.organization.id}/checkout${session}#form`
      },
      onEmptyCart() {
        this.tab = 1
        this.$nextTick(() => {
          this.invoice = null
        })
      },
      loadCart() {
        this.busy = true
        this.error = null
        axios.get(`/org/${this.organization.id}/cart`)
        .then(response => {
          this.busy = false
          this.invoice = !_.isEmpty(response.data) ? response.data : null
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      }
    },
    mounted() {
      window.packageCategoryTabs = this
      _.cleanupServerSideElements()
      if (!this.showCalendar) this.onUrlChange()
      this.loadCart()
    },
  }
</script>